export default defineNuxtRouteMiddleware(async (to) => {
});
